import {mapMutations} from 'vuex';
import {
    CHANGE_OPEN_SECOND_MENU,
    SET_PROPS_SECOND_MENU
} from '@/store/mutation-types';
export default {
    name: 'catalog-list-mobile',
    props: ['list'],
    methods: {
        ...mapMutations({
            changeShowSecondMenu: `system/${CHANGE_OPEN_SECOND_MENU}`,
            setPropsSecondMenu: `system/${SET_PROPS_SECOND_MENU}`
        }),
        changeSecondMenu(item){
            this.setPropsSecondMenu(item);
            this.changeShowSecondMenu(true);
        }
    }
}
